import { baseUrl, handleResponse, handleError, GetHeaders } from "../../../../apis/common/ApiUtils";

const apiUrl = baseUrl + "Travel";

export function getTravelTotals(allowanceTypeId) {
  // If isImpersonation is true and managerId is provided, use impersonation endpoint
  const url = `${apiUrl}/totals/${allowanceTypeId}`;
    
  return fetch(url, GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function getUserTravelDetails(employeeId, managerId, isImpersonation) {
  let url = null;
  if(isImpersonation) {
    url = `${apiUrl}/details/${employeeId}/as/${managerId}`;
  } else {
    url = `${apiUrl}/details/${employeeId}`
  }
  
  return fetch(url, GetHeaders())
  .then(handleResponse)
  .catch(handleError);
}